// extracted by mini-css-extract-plugin
module.exports = {"thumbSection":"style__thumbSection__pW0-C","thumbSectionBottom":"style__thumbSectionBottom__heIj3"};